export default __webpack_public_path__ + "static/media/gps-log-example.07be8f5d.png";